export const ShareUrlRenditions = {
    Small: 'downsized',
    Social: 'fixed_width',
    Original: 'original',
    OriginalStill: 'original_still',
    MP4: 'original_mp4',
} as const

export type ShareUrlRenditionType = (typeof ShareUrlRenditions)[keyof typeof ShareUrlRenditions]
